import { userService } from '../services/userService';
import { clearJsonCache } from '../services/axiosInterceptor';
import { benefitsService } from '@/services/benefitsService';
import { getTenantConfig } from '@/services/tenantService';

/** Retorna a URL de redirect (logout_redirect do tenant ou /auth/login). Útil para páginas de erro de login. */
export const getLogoutRedirectUrl = () => {
  const tenantConfig = getTenantConfig();
  const logoutRedirect = tenantConfig?.FEATURE_FLAGS?.logout_redirect;
  return logoutRedirect || '/auth/login';
};

export const handleLogout = () => {
  try {
    userService.logout();
    clearJsonCache();
    benefitsService.clearCache();

    const redirectUrl = getLogoutRedirectUrl();
    window.location.href = redirectUrl;
  } catch (error) {
    console.error('Erro durante o logout:', error);
  }
}; 
